import { TOTAL_SCREENS } from './commonUtils';
import { Subject } from 'rxjs';
import {object} from 'prop-types'

export default class ScrollService {
    static scrollHandler = new ScrollService();

    static currScreenBroCaster = new Subject();
    static currScreenFadeIn = new Subject();

    constructor() {
        window.addEventListener('scroll', this.checkCurrentScreenUnderViewport);
    }

    scrollToHireMe = () => {
        let contactMeScreen = document.getElementById("Contact Me");
        if (!contactMeScreen) return;
        contactMeScreen.scrollIntoView({ behavior: "smooth" })
    }

    scrollToHome = () => {
        let homeScreen = document.getElementById("Home");
        if (!homeScreen) return;
        homeScreen.scrollIntoView({ behavior: "smooth" })
    }

    isElementInView = (elem, type) => {
        let rec = elem.getBoundingClientRect();
        let elemTop = rec.top;
        let elemBottom = rec.Bottom;

        let partVisible = elemTop < window.innerHeight && elemBottom >= 0;
        let comVisible = elemTop >= 0 && elemBottom <= window.innerHeight;

        switch (type) {
            case "partial":
                return partVisible;
            case "complete":
                return comVisible;
            default:
                return false
        }
    }

    checkCurrentScreenUnderViewport = (event) =>{
        if(!event || object.keys(event).length < 1)
        return;
        for(let screen of TOTAL_SCREENS){
            let screenFromDom = document.getElementById(screen.screen_name);
            if(!screenFromDom)
            continue;

            let fullyVisi = this.isElementInView(screenFromDom,"complete")
            let partialVisi = this.isElementInView(screenFromDom,"partial")

            if(fullyVisi || partialVisi){
                if(partialVisi && !screen.alreadyRendered){
                    ScrollService.currScreenFadeIn.next({
                        fadeInScreen: screen.screen_name
                    });
                    screen['alreadyRenderes'] =true;
                    break;
                }
                if(fullyVisi){
                    ScrollService.currScreenBroCaster.next({
                        screenInView : screen.screen_name
                    });
                    break;
                }
            }
        }
    }
}